/**
 * Escalas compartidas por los átomos de layout/tipografía (`Stack`, `Group`,
 * `Text`, `Heading`, `Card`…) · mismos nombres de escala que Mantine
 * (`xs · sm · md · lg · xl`) para que migrar un call-site sea casi un
 * cambio de import, no una reescritura de props.
 */

/** `spacing` de `mantine-theme.ts` · xs=8 · sm=12 · md=16 · lg=24 · xl=32 (px). */
export const GAP_CLASS = {
  xs: "gap-2",
  sm: "gap-3",
  md: "gap-4",
  lg: "gap-6",
  xl: "gap-8",
} as const;

export const PADDING_CLASS = {
  xs: "p-2",
  sm: "p-3",
  md: "p-4",
  lg: "p-6",
  xl: "p-8",
} as const;

/** `fontSizes` de `mantine-theme.ts` · registrados como `--text-*` en globals.css. */
export const TEXT_SIZE_CLASS = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-base",
  lg: "text-lg",
  xl: "text-xl",
} as const;

export type Scale = keyof typeof GAP_CLASS;

/** Acepta la escala nombrada (`"md"`) o un número crudo en px, como Mantine. */
export type Gap = Scale | number;

export type Align =
  | "stretch"
  | "flex-start"
  | "center"
  | "flex-end"
  | "baseline";

export type Justify =
  | "flex-start"
  | "center"
  | "flex-end"
  | "space-between"
  | "space-around";
